import { PATH_CUENTA_DETAIL } from '../../../navigation/navigation.module';
import { environment } from '../../../../environments/environment.prod';
import { Component, OnInit } from '@angular/core';
import { CuentasService } from '../../../services/cuentas-service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DialogsService } from '../../../services/dialogs-service';
import { NavigationService } from '../../../services/navigation-service';
import { ENTITY_TYPE_CONTACTO } from '../../common/activity-list/activity-list.component';
import { PATH_CUENTAS } from '../../../navigation/navigation.module';

@Component({
  selector: 'app-contacto-detail',
  templateUrl: './contacto-detail.component.html',
  styleUrls: ['./contacto-detail.component.scss']
})
export class ContactoDetailComponent implements OnInit {

  private contacto;
  private contactoId;
  private actividad = [];
  ENTITY_TYPE_CONTACTO = ENTITY_TYPE_CONTACTO;
  ASSETS_URL = environment.ASSETS_URL;

  estadisticasConsignas = 0;
  estadisticasLogros = 0;
  estadisticasPuntos = 0;

  actividadPage: number = 0;
  lastActividadPage: number;
  lastActividadDate = 0;

  private cuentaFullName: string;

  private dataValid: boolean = true;

  constructor(private route: ActivatedRoute,
              private cuentasService: CuentasService,
              private location: Location,
              private router: Router,
              private dialogsService: DialogsService,
              private navService: NavigationService) { }

  ngOnInit() {
    this.loadContacto();
  }

  navigateToCuenta(cuentaId){
    this.router.navigate([PATH_CUENTA_DETAIL, cuentaId])
  }

  loadContacto(){
    this.route.params.subscribe(params => {

      this.contactoId = this.route.snapshot.params['id'];

      this.cuentasService.getContacto(this.contactoId)
        .subscribe(value => {
          this.contacto = value;
          console.log(value);

          if (!this.contacto) {
            this.dataValid = false;
            return;
          }

          this.cuentasService.getCuenta(this.contacto.ClienteId)
            .subscribe(value => {
              this.cuentaFullName = value.FullName;
            });

          this.getActividad();
        }, err => this.dataValid = false);
    });

    this.cuentasService.getEstadisticasContacto(this.contactoId)
      .subscribe( data => {
        let { ResponseData } = data;
        this.estadisticasConsignas = ResponseData.ConsignasCantidad;
        this.estadisticasLogros = ResponseData.LogrosPorcentaje;
        this.estadisticasPuntos = ResponseData.Puntos;
    });
  }

  getActividad() {
    // si se busca la misma pagina dos veces se replican los resultados, no buscar a menos que sean paginas distintas
    // la pagina a buscar cambia al llegar al fondo al hacer scroll, solo entonces refrescar actividades
    if (this.lastActividadPage !== this.actividadPage) {
      this.lastActividadPage = this.actividadPage;
      this.cuentasService.getActividad(this.contacto.ClienteId, this.actividadPage)
      .subscribe( value => {
        this.actividad = [...this.actividad, ...value.ResponseData];
        this.lastActividadDate = this.actividad.length ? this.actividad[0].FechaHora : 0;
      });
    }
  }

  navigateBack(){
    if (this.navService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/'+PATH_CUENTAS);
    }
  }

  showNewConsignaDialog(){
    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES', null, null, this.contacto);
  }

  editContacto(){
    this.dialogsService.showNewContactoDialog(
      'Editar Contacto',
      this.contacto,
      'GUARDAR',
      'CANCELAR'
    ).subscribe( () => {
      this.loadContacto();
    });
  }

  onBottomReached(reached: boolean) {
    this.actividadPage++;
    this.getActividad();
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/contacto-detail/contacto-detail.component.ts